import "./cardCursos.css";
import BtnPost from "../../../../shared/btn/btn";
import assetsRoute from "../../../../utilities/assetsRoute";

const CardCursos = (props) => {
  const Iconroute = `/wp-content/themes/observatorio-omt-web/assets/icons/`;
  const data = props.data;
  const key = props.key ? props.key : 1;

  const {
    access,
    id,
    title,
    date,
    featuredImg,
    slug,
    content,
    excerpt,
    link,
    idiomas,
    courseInstructor,
    courseWeeks,
    courseLevels,
    courseSQuizzes,
    courseStudents,
    coursePrice,
    pastCondition,
  } = data;

  const htmlLang = document.documentElement.lang;
  const baseUrl = link.split(".org")[0] + ".org";
  const urlPath = new URL(link);
  const pathAfterDomain = urlPath.pathname;

  const isLangEnUS = htmlLang === "en-US";

  const url = environment.DOMAIN;

  const finalLink = isLangEnUS
    ? `${baseUrl}/en${pathAfterDomain}`
    : `${baseUrl}${pathAfterDomain}`;

  const regex = /\d/g;
  const numerosEncontrados = courseWeeks.match(regex);

  let weeksNumber;

  if (numerosEncontrados) {
    weeksNumber = parseInt(numerosEncontrados.join(""), 10);
  }

  return (
    <ul className="learn-press-courses" data-layout="list">
      <li
        id={id}
        className={`post-${id} lp_course type-lp_course status-publish has-post-thumbnail hentry course`}
      >
        <div className="course-item">
          <div className="course-wrap-thumbnail">
            <div className="course-thumbnail">
              <a href={finalLink}>
                <div className="thumbnail-preview">
                  <div className="thumbnail">
                    <div className="centered">
                      <img
                        width="500"
                        height="166"
                        src={featuredImg}
                        className="attachment-500x300 size-500x300 wp-post-image"
                        alt="Curso de ejemplo 2"
                        title="Curso de ejemplo 2"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          {/* <!-- START .course-content --> */}
          <div className="course-content">
            <span className="course-instructor">{courseInstructor}</span>
            <a href={finalLink} className="course-permalink">
              <h3 className="course-title">{title}</h3>
            </a>

            {/* <!-- START .course-content-meta --> */}
            <div className="course-wrap-meta">
              <div className="meta-item meta-item-duration">
                {weeksNumber}{" "}
                <span>{weeksNumber > 1 ? "Semanas" : "Semana"}</span>
              </div>
              <div className="meta-item meta-item-quiz">
                <span className="meta-number">
                  {courseSQuizzes} cuestionarios
                </span>
              </div>
              <div className="language">
                {idiomas?.map((idioma, index) => {
                  return (
                    <div key={index}>
                      <img
                        className="img-language"
                        src={`${url + Iconroute}idioma.svg`}
                        alt=""
                      />
                      <span>{idioma}</span>
                    </div>
                  );
                })}
              </div>
              {courseStudents && (
                <div className="meta-item meta-item-student">
                  <span className="meta-number">
                    {courseStudents} estudiantes
                  </span>
                </div>
              )}
            </div>

            {/* <!-- END .course-content-meta --> */}
            <div className="separator"></div>
            <div className="course-info">
              <div
                className="course-excerpt"
                dangerouslySetInnerHTML={{ __html: content }}
              ></div>

              <div className="clearfix"></div>
              {/* <!-- START .course-content-footer -->  */}
              {coursePrice != 0 && (
                <div className="course-footer">
                  <div className="course-price">
                    <span className="course-item-price">
                      <span className="free">
                        {coursePrice == 0 ? "Gratis" : coursePrice}
                      </span>
                    </span>
                  </div>
                </div>
              )}
              {/* <!-- END .course-content-footer -->		 */}
              <BtnPost
                btnLink={finalLink}
                text={"Saber más"}
                svgIcon={environment.DOMAIN + "/wp-content/themes/observatorio-omt-web/assets/icons/arrow-right-white.svg"}
                btnType={"primary-botton"}
              />
            </div>
          </div>
          {/* <!-- END .course-content -->	 */}
        </div>
      </li>
    </ul>
  );
};

export default CardCursos;
